/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_Confirm_DescriptionInputs */

const es_chat_edit_confirm_description = /** @type {(inputs: Chat_Edit_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar este mensaje eliminará todos los mensajes posteriores y generará una nueva respuesta.`)
};

const en_chat_edit_confirm_description = /** @type {(inputs: Chat_Edit_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editing this message will delete all subsequent messages and generate a new response.`)
};

/**
* | output |
* | --- |
* | "Editing this message will delete all subsequent messages and generate a new response." |
*
* @param {Chat_Edit_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_edit_confirm_description = /** @type {((inputs?: Chat_Edit_Confirm_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_Confirm_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_edit_confirm_description(inputs)
	return en_chat_edit_confirm_description(inputs)
});
export { chat_edit_confirm_description as "chat.edit.confirm_description" }